import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  MenuItem,
  Switch,
} from '@material-ui/core';
import {
  FormikProps,
  validateYupSchema,
  withFormik,
  yupToFormErrors,
} from 'formik';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Info } from 'react-feather';
import { injectIntl, IntlShape } from 'react-intl';

import { pushTo } from 'helpers/routes';
import PolicyNumberModal from 'components/AddNewContractModal/PolicyNumberModal';
import { OrangeButton } from 'components/Button';
import InputField from 'components/InputField';
import PhoneMaskInput from 'components/InputField/PhoneMaskInput';
import Modal from 'components/Modal';
import SelectInputField from 'components/SelectInputField';
import { Captions } from 'components/Typography';
import ActionsButtons from 'containers/SignupPages/ActionsButtons';
import {
  GeneralConditions,
  StyledBodyText,
} from 'containers/SignupPages/IdMemo/styles';
import messages from 'containers/SignupPages/PersonalInfo/messages';
import {
  BoxGeneraleCon,
  GridChechBox,
  GridConditionText,
  SizedLongBody,
  StyledCaptions,
} from 'containers/SignupPages/PersonalInfo/styles';
import validationSchema from 'containers/SignupPages/PersonalInfo/validationSchema';
import { translate } from 'helpers/intl';
import { sanlamAccentGrey } from 'Material-UI/colors';
import { isFieldRequired } from 'utils/string';
import pages from 'routes/pages';
import { PRIVILEGES } from 'utils/globalConst';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { cgu } from 'translations/cgu';
import { get } from 'lodash';
import HealthInsuranceFields from './HealthInsuranceFields';
import { handleSubmit as _handleSubmit } from './utils';

const InnerForm = (props: FormProps & FormikProps<FormValues>) => {
  const {
    values,
    touched,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    isLoading,
    setFieldValue,
  } = props;
  const language = useSelector(getLocaleSelector);
  const [open, setOpen] = useState(false);
  const [isPolicyNumberModalOpen, setIsPolicyNumberModalOpen] = useState<
    boolean
  >(false);

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleIsTermsAccepted = () => {
    setFieldValue('isAcceptConditions', true);
    setOpen(false);
  };

  const handleOnClickPrevious = () => {
    pushTo(pages.LOGIN);
    localStorage.removeItem('personalInfo');
  };

  return (
    <GaLoadHOC
      category={EVENT_CATEGORIES.LOGIN_CREATION}
      label="Chargement de la page"
    >
      <form onSubmit={handleSubmit}>
        <Box mb={3} paddingX={[2, 8, 12]}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <InputField
                name="lastName"
                label={translate({ ...messages.lastName }, props)}
                placeholder={translate({ ...messages.lastName }, props)}
                value={values.lastName}
                error={errors.lastName && touched.lastName}
                helperText={touched.lastName && errors.lastName}
                handleChange={
                  /* istanbul ignore next */
                  (event: any) => {
                    if (
                      event.target.value !== '' &&
                      /^[a-zA-Z- ]+$/.test(event.target.value)
                    ) {
                      handleChange(event);
                    } else if (event.target.value === '') {
                      handleChange(event);
                    }
                  }
                }
                handleBlur={handleBlur}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputField
                name="firstName"
                label={translate({ ...messages.firstName }, props)}
                placeholder={translate({ ...messages.firstName }, props)}
                value={values.firstName}
                error={errors.firstName && touched.firstName}
                helperText={touched.firstName && errors.firstName}
                handleChange={
                  /* istanbul ignore next */
                  (event: any) => {
                    if (
                      event.target.value !== '' &&
                      /^[a-zA-Z- ]+$/.test(event.target.value)
                    ) {
                      handleChange(event);
                    } else if (event.target.value === '') {
                      handleChange(event);
                    }
                  }
                }
                handleBlur={handleBlur}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <InputField
                name="birthday"
                label={translate({ ...messages.birthday }, props)}
                placeholder={translate({ ...messages.birthday }, props)}
                value={values.birthday}
                type="date"
                error={errors.birthday && touched.birthday}
                helperText={touched.birthday && errors.birthday}
                handleChange={handleChange}
                handleBlur={handleBlur}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputProps: { max: '9999-12-30' },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <InputField
                name="cin"
                label={translate({ ...messages.cin }, props)}
                placeholder={translate({ ...messages.cin }, props)}
                value={values.cin}
                error={errors.cin && touched.cin}
                helperText={touched.cin && errors.cin}
                handleChange={
                  /* istanbul ignore next */
                  (event: any) => {
                    if (
                      event.target.value !== '' &&
                      /^[a-zA-Z0-9]+$/.test(event.target.value)
                    ) {
                      handleChange(event);
                    } else if (event.target.value === '') {
                      handleChange(event);
                    }
                  }
                }
                handleBlur={handleBlur}
              />
            </Grid>

            <Box paddingX={2}>
              <Box marginBottom={2}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={values.isAssuranceSante}
                      onChange={
                        /* istanbul ignore next */ (event) => {
                          if (event.target.checked && values.isContratEpargne)
                            setFieldValue('isContratEpargne', false, false);
                          handleChange(event);
                        }
                      }
                      name="isAssuranceSante"
                      color="primary"
                    />
                  }
                  label={translate({ ...messages.haveAssuranceSante }, props)}
                />
                {values.isAssuranceSante && (
                  <Box marginY={3}>
                    <HealthInsuranceFields
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      organization={values.organization}
                      membershipNumber={values.membershipNumber}
                      touched={touched}
                      drpp={values.drpp}
                      errors={errors}
                    />
                  </Box>
                )}
                <FormControlLabel
                  control={
                    <GaClickHOC
                      category={EVENT_CATEGORIES.LOGIN_CREATION}
                      label="Checkbox Adhérent Épargne"
                    >
                      <Switch
                        checked={values.isContratEpargne}
                        data-testid="switch"
                        onChange={
                          /* istanbul ignore next */ (event) => {
                            if (event.target.checked && values.isAssuranceSante)
                              setFieldValue('isAssuranceSante', false, false);
                            handleChange(event);
                          }
                        }
                        onClick={() => {
                          if (!values.isContratEpargne) {
                            props.setLoadingProducts(true);
                          }
                        }}
                        name="isContratEpargne"
                        color="primary"
                      />
                    </GaClickHOC>
                  }
                  label={translate({ ...messages.haveContratEpargne }, props)}
                />
              </Box>
              {values.isContratEpargne && (
                <Box marginY={3}>
                  <Grid
                    container
                    direction="column"
                    spacing={3}
                    justify="center"
                  >
                    {props.isLoadingProducts || props.products?.length === 0 ? (
                      <Grid container justify="center">
                        <Grid item>
                          <CircularProgress data-testid="loader" />
                        </Grid>
                      </Grid>
                    ) : (
                      <>
                        <Grid item xs={12}>
                          <SelectInputField
                            name="product"
                            label={translate(
                              { ...messages.selectionnezProduit },
                              props,
                            )}
                            error={errors.product && touched.product}
                            helperText={touched.product && errors.product}
                            value={values.product}
                            handleBlur={handleBlur}
                            onChange={handleChange}
                            SelectDisplayProps={{
                              id: 'select-id2',
                              'data-testid': 'select-product',
                            }}
                            Children={[...(props.products || [])].map(
                              (
                                item: { value: string; label: string },
                                index: number,
                              ) => (
                                <MenuItem
                                  data-testid="select-option-2"
                                  value={item.value}
                                  key={index}
                                >
                                  {item.label}
                                </MenuItem>
                              ),
                            )}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <InputField
                            name="numPolice"
                            InputProps={{
                              'data-testid': 'numPolice',
                            }}
                            label={translate({ ...messages.numPolice }, props)}
                            value={values.numPolice}
                            error={errors.numPolice && touched.numPolice}
                            helperText={touched.numPolice && errors.numPolice}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            endAdornment={
                              <Info
                                data-testid="input-numPolice"
                                style={{ cursor: 'pointer' }}
                                onClick={() => setIsPolicyNumberModalOpen(true)}
                              />
                            }
                          />
                          <PolicyNumberModal
                            open={isPolicyNumberModalOpen}
                            handleOpen={
                              /* istanbul ignore next */
                              () => setIsPolicyNumberModalOpen(true)
                            }
                            handleClose={() =>
                              setIsPolicyNumberModalOpen(false)
                            }
                            typeAssurance={
                              values.isContratEpargne ? PRIVILEGES.EPARGN : null
                            }
                          />
                        </Grid>
                        {isFieldRequired(
                          props.products,
                          values.product,
                          'ppr',
                        ) && (
                          <Grid item xs={12}>
                            <InputField
                              name="ppr"
                              label={translate(
                                { ...messages.ppr_field },
                                props,
                              )}
                              value={values.ppr}
                              error={errors.ppr && touched.ppr}
                              helperText={touched.ppr && errors.ppr}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              InputProps={{
                                'data-testid': 'input-ppr',
                              }}
                            />
                          </Grid>
                        )}
                        {isFieldRequired(
                          props.products,
                          values.product,
                          'numAdhesion',
                        ) && (
                          <Grid item xs={12}>
                            <InputField
                              name="numAdhesion"
                              label={translate(
                                { ...messages.numero_adhesion },
                                props,
                              )}
                              value={values.numAdhesion}
                              error={errors.numAdhesion && touched.numAdhesion}
                              helperText={
                                touched.numAdhesion && errors.numAdhesion
                              }
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              InputProps={{
                                'data-testid': 'input-numAdhesion',
                              }}
                            />
                          </Grid>
                        )}

                        {isFieldRequired(
                          props.products,
                          values.product,
                          'matricule',
                        ) && (
                          <Grid item xs={12}>
                            <InputField
                              name="matricule"
                              label={translate(
                                { ...messages.matricule_field },
                                props,
                              )}
                              value={values.matricule}
                              error={errors.matricule && touched.matricule}
                              helperText={touched.matricule && errors.matricule}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              InputProps={{
                                'data-testid': 'input-matricule',
                              }}
                            />
                          </Grid>
                        )}

                        <Grid item xs={12}>
                          <InputField
                            name="dateEffet"
                            InputProps={{
                              'data-testid': 'dateEffet',
                              inputProps: { max: '9999-12-30' },
                            }}
                            label={translate({ ...messages.dateEffet }, props)}
                            value={values.dateEffet}
                            type="date"
                            placeholder={translate(
                              { ...messages.dateEffet },
                              props,
                            )}
                            error={errors.dateEffet && touched.dateEffet}
                            helperText={touched.dateEffet && errors.dateEffet}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Box>
              )}

              <Grid style={{ marginBottom: 18 }} item xs={12}>
                <InputField
                  name="email"
                  label={translate({ ...messages.email }, props)}
                  placeholder={translate({ ...messages.email }, props)}
                  value={values.email}
                  error={errors.email && touched.email}
                  helperText={touched.email && errors.email}
                  handleChange={
                    /* istanbul ignore next */
                    (event: any) => {
                      if (
                        event.target.value !== '' &&
                        /^[\w@.+_-]*$/.test(event.target.value)
                      ) {
                        handleChange(event);
                      } else if (event.target.value === '') {
                        handleChange(event);
                      }
                    }
                  }
                  handleBlur={handleBlur}
                />
              </Grid>

              <Grid style={{ marginBottom: 18 }} item xs={12}>
                <InputField
                  name="phoneNumber"
                  label={translate({ ...messages.phoneNumber }, props)}
                  placeholder={translate({ ...messages.phoneNumber }, props)}
                  value={values.phoneNumber}
                  error={errors.phoneNumber && touched.phoneNumber}
                  helperText={touched.phoneNumber && errors.phoneNumber}
                  handleChange={
                    /* istanbul ignore next */
                    (event: any) => {
                      if (
                        event.target.value !== '' &&
                        /^[0-9+ ]+$/.test(event.target.value)
                      ) {
                        handleChange(event);
                      } else if (event.target.value === '') {
                        handleChange(event);
                      }
                    }
                  }
                  handleBlur={handleBlur}
                  InputProps={{
                    inputComponent: PhoneMaskInput,
                  }}
                />
              </Grid>

              <Captions color={sanlamAccentGrey}>
                {translate({ ...messages.loiParagraph }, props)}
              </Captions>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values.isContacterParSaham}
                    onChange={handleChange}
                    name="isContacterParSaham"
                    color="primary"
                  />
                }
                label={translate({ ...messages.contacterParSaham }, props)}
              />
              <BoxGeneraleCon>
                <Grid container direction="row" alignItems="center">
                  <GridChechBox xs={2} sm={1} item>
                    <GaClickHOC
                      category={EVENT_CATEGORIES.LOGIN_CREATION}
                      label="Checkbox Conditions générales"
                    >
                      <Checkbox
                        color="primary"
                        name="isAcceptConditions"
                        value={values.isAcceptConditions}
                        onChange={handleChange}
                        checked={values.isAcceptConditions}
                        data-testid="accept-conditions"
                      />
                    </GaClickHOC>
                  </GridChechBox>
                  <GridConditionText xs={10} sm={11} item>
                    <Box>
                      <StyledCaptions>
                        {translate({ ...messages.iAccept }, props)}{' '}
                        <GaClickHOC
                          category={EVENT_CATEGORIES.LOGIN_CREATION}
                          label="Conditions générales d'utilisation"
                        >
                          <GeneralConditions
                            data-testid="terms-and-conditions"
                            onClick={() => {
                              handleOpenModal();
                            }}
                          >
                            {translate(
                              { ...messages.termsAndConditions },
                              props,
                            )}
                          </GeneralConditions>
                        </GaClickHOC>
                        {translate({ ...messages.personalData }, props)}
                      </StyledCaptions>
                      {errors.isAcceptConditions &&
                        touched.isAcceptConditions && (
                          <Captions color={'#F5523C'}>
                            {errors.isAcceptConditions}
                          </Captions>
                        )}
                    </Box>
                  </GridConditionText>
                </Grid>
              </BoxGeneraleCon>
            </Box>
          </Grid>
        </Box>

        <ActionsButtons
          nextGACategory={EVENT_CATEGORIES.LOGIN_CREATION}
          previousGACategory={EVENT_CATEGORIES.LOGIN_CREATION}
          previousGALabel="Retour à l'écran principal"
          onClickPrevious={handleOnClickPrevious}
          isLoading={isLoading}
        />

        <Modal
          open={open}
          handleOpen={handleOpenModal}
          handleClose={handleCloseModal}
          header={
            <SizedLongBody weight="500" color="#04336B">
              {translate({ ...messages.modalTitle }, props)}
            </SizedLongBody>
          }
          content={<StyledBodyText>{cgu[language]}</StyledBodyText>}
          footer={
            <Grid spacing={5} container justify="flex-end">
              <Grid item>
                <OrangeButton onClick={handleCloseModal}>
                  {translate({ ...messages.close }, props)}
                </OrangeButton>
              </Grid>
              <Grid item>
                <GaClickHOC
                  category={EVENT_CATEGORIES.LOGIN_CREATION}
                  label="Bouton Accepter"
                >
                  <OrangeButton
                    variant="contained"
                    onClick={handleIsTermsAccepted}
                  >
                    {translate({ ...messages.accept }, props)}
                  </OrangeButton>
                </GaClickHOC>
              </Grid>
            </Grid>
          }
        ></Modal>
      </form>
    </GaLoadHOC>
  );
};

export interface FormProps {
  intl: IntlShape;
  onSubmit: Function;
  isLoading: boolean;
  isLoadingProducts?: boolean;
  products?: any[];
  setLoadingProducts?: any;
}

interface FormValues {
  firstName: string;
  lastName: string;
  birthday: string;
  cin: string;
  email: string;
  phoneNumber: string;

  isAssuranceSante: boolean;
  isContratEpargne: boolean;
  isContacterParSaham: boolean;
  isAcceptConditions: boolean;

  //epargn
  product: any;
  numPolice: string;
  dateEffet: string;

  // conditional fields
  ppr: string;
  numAdhesion: string;
  matricule: string;

  organization: any;
  drpp: string;
  membershipNumber: string;
}
const Form = withFormik<FormProps, FormValues>({
  mapPropsToValues: () => {
    const localData = localStorage.getItem('personalInfo');
    const data = localData && JSON.parse(localData);

    return {
      firstName: get(data, 'firstName', ''),
      lastName: get(data, 'lastName', ''),
      birthday: get(data, 'birthday', ''),
      cin: get(data, 'cin', ''),
      email: get(data, 'email', ''),
      phoneNumber: get(data, 'phone', ''),
      isAssuranceSante: false,
      isContratEpargne: false,
      isContacterParSaham: false,
      isAcceptConditions: false,
      product: '',
      numPolice: '',
      ppr: '',
      numAdhesion: '',
      matricule: '',
      dateEffet: '',
      organization: null,
      drpp: '',
      membershipNumber: '',
    };
  },

  validate: (values: any, props: any) => {
    const schema = validationSchema(props, values);
    try {
      validateYupSchema<FormValues>(values, schema, true);
    } catch (err) {
      return yupToFormErrors(err);
    }
    return {};
  },

  handleSubmit: _handleSubmit,
})(InnerForm);

export default injectIntl(Form);
